/**
 * The different types of drag operations supported for calendar items
 */
export const enum DragOperationType {
    Drag = 0,
    ResizeTop = 1,
    ResizeBottom = 2,
    ResizeLeft = 3,
    ResizeRight = 4,
}
